/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface NetSuiteCredentials
 */
export interface NetSuiteCredentials {
  /**
   *
   * @type {string}
   * @memberof NetSuiteCredentials
   */
  issuer: string;
  /**
   *
   * @type {string}
   * @memberof NetSuiteCredentials
   */
  kid: string;
  /**
   *
   * @type {string}
   * @memberof NetSuiteCredentials
   */
  privateKeyPem: string;
}

/**
 * Check if a given object implements the NetSuiteCredentials interface.
 */
export function instanceOfNetSuiteCredentials(
  value: object,
): value is NetSuiteCredentials {
  if (!("issuer" in value) || value["issuer"] === undefined) return false;
  if (!("kid" in value) || value["kid"] === undefined) return false;
  if (!("privateKeyPem" in value) || value["privateKeyPem"] === undefined)
    return false;
  return true;
}

export function NetSuiteCredentialsFromJSON(json: any): NetSuiteCredentials {
  return NetSuiteCredentialsFromJSONTyped(json, false);
}

export function NetSuiteCredentialsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NetSuiteCredentials {
  if (json == null) {
    return json;
  }
  return {
    issuer: json["issuer"],
    kid: json["kid"],
    privateKeyPem: json["privateKeyPem"],
  };
}

export function NetSuiteCredentialsToJSON(json: any): NetSuiteCredentials {
  return NetSuiteCredentialsToJSONTyped(json, false);
}

export function NetSuiteCredentialsToJSONTyped(
  value?: NetSuiteCredentials | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    issuer: value["issuer"],
    kid: value["kid"],
    privateKeyPem: value["privateKeyPem"],
  };
}
